import React, { useState } from 'react';
import Button from './button';
import Icon from './icon';
import Input from './input';


const Form = ({ handleSubmit, inputStyles, inputData, icon }) => {

    const initialState = { [inputData.name]: "" }
    const [inputfield, setinputfield] = useState(initialState);


    const handleInputChange = (event) => {
        const { name, value } = event.target

        setinputfield({ ...inputfield, [name]: value })
    }



    return (<>
        <div className="container">
            <form onSubmit={e => {
                e.preventDefault()
                handleSubmit(inputfield)
                setinputfield(initialState)
            }} >
                <div className='container flex-col mb-3'>
                    <label htmlFor={inputData.text} className='text-gray-500 p-3 mb-5 text-xl' hidden={true}>Notes</label>
                    <div className='container my-2 mx-1 flex justify-self-stretch items-center'>
                        <Button name={<Icon iconName={icon.iconName} styles={icon.iconStyles} />} />
                        <Input
                            text={inputData.text}
                            value={inputfield.notes}
                            placeholder={inputData.placeholder}
                            name={inputData.name}
                            className={inputStyles}
                            id={inputData.id}
                            onChange={handleInputChange}
                            min={inputData.min}
                            max={inputData.max}
                        >
                        </Input>
                    </div>

                </div>

            </form>
        </div>
    </>);
}

export default Form;